import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './style.less';
import {HEADER_MENU} from "./default_informations/header_menu";

import Loader from "./components/Loader";
import Home from "./pages/Home";
const Page = React.lazy(() => import("./pages/Page"));
const Heroes = React.lazy(() => import("./pages/Heroes"));
//const NotFound = React.lazy(() => import("./pages/NotFound"));

function App() {
    const headerMenu = HEADER_MENU;

    return (
        <Router>
            <Suspense fallback={<Loader />}>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/all-heroes/" component={Heroes} />
                    {
                        headerMenu.map(item => (item.link !== '/') && (<Route key={item.id} path={item.link} component={() => <Page page_id={item.id} />}/>))
                    }
                    <Route component={Home} />
                </Switch>
            </Suspense>
        </Router>
    )
}

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
/*
ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById('root')
);
*/